import { createConfig, lazyRoute } from "../config/config-utils"
import { WHEN } from "../config/constants"

const SpeedReaderApp = lazyRoute(
  ()=> import("./SpeedReaderApp"),
  "SpeedReaderApp",
)

export const SPEED_READER_CONFIG = createConfig({
  component: SpeedReaderApp,
  key: "speed-reader",
  label: "Speed Reader",
  when: WHEN,
})
